<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title">{{$t('label_431')}}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 70px;">
                      <p>{{$t('label_383')}}</p>
                    </div>
                    <el-select v-model="Warehouseid" :placeholder="$t('input_65')"
                               @change="updateTable" clearable>
                      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 70px;">
                      <p>{{$t('label_422')}}</p>
                    </div>
                    <div class="select">
                      <el-input v-model="taskName" clearable></el-input>
                    </div>
                  </div>
                  <div class="selectChoose" >
                    <div class="selectText" style="width: 100px;">
                      <p>{{$t('label_412')}}</p>
                    </div>
                    <el-select v-model="Warehouseidtype" :placeholder="$t('input_65')"
                               @change="typenumber" clearable>
                      <el-option v-for="item in optionstype" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" :style="{'height':'calc(100% - 150px)'}">
              <div class="tableMin" style="height: calc(100% - 100px);">
                <!--button按钮-->
                <div class="buttonBox" style="margin-bottom: 10px;">
                  <div>
                    <div class="chooseButton searchButton"  @click="Inventorycli" v-if="MenuRoleList.indexOf('148')>=0">
                      <i class="el-icon-paperclip"></i>{{$t('btn_54')}}
                    </div>
                    <div class="chooseButton searchButton" style="background: red"  @click="open" v-if="MenuRoleList.indexOf('149')>=0">
                      <i class="el-icon-delete"></i>{{$t('btn_16')}}
                    </div>
                    <div class="chooseButton searchButton" style="background: #848484" @click="tovoid" v-if="MenuRoleList.indexOf('150')>=0">
                      <i class="el-icon-circle-close"></i>{{$t('btn_5')}}
                    </div>
                    <div class="chooseButton searchButton" style="background: #409EFF" @click="Inventorycli(1)" v-if="MenuRoleList.indexOf('151')>=0">
                      <i class="el-icon-view"></i>{{$t('btn_38')}}
                    </div>
                  </div>
                </div>
                <!--table start-->
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
                          @current-change="handleCurrentChangeTree" border style="width: 100%;" height="100%"
                          :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"  v-loading="loading">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column
                    :label="$t('label_327')"
                    align="left"
                    prop="warehouseName"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('label_422')"
                    align="left"
                    prop="name"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    :label="$t('label_441')"
                    align="createTime"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="createUser"
                    :label="$t('label_445')"
                    align="createUser"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="inventoryTime"
                    :label="$t('label_449')"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="inventoryUser"
                    :label="$t('label_453')"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    :label="$t('label_412')"
                    align="left"
                  >
                    <template slot-scope="scope">
                     <span v-if="scope.row.state==1">{{$t('label_457')}}</span>
                     <span v-if="scope.row.state==2">{{$t('label_591')}}</span>
                    <span v-if="scope.row.state==3">{{$t('label_462')}}</span>
                    <span v-if="scope.row.state==9">{{$t('btn_5')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="position: absolute;bottom: 30px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                        @parentMethod="searchPage"></Page>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <!--弹框-->
    <el-dialog :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
               width="85%" top="2%" :before-close="handleClose" custom-class="dialogBox">
      <div v-if="typestate==false">
      <div class="buttonBox" style="margin-bottom: 10px;">
        <div>
          <div class="chooseButton searchButton"  @click="zancun">
            <i class="el-icon-folder-opened"></i>{{$t('label_591')}}
          </div>
          <div class="chooseButton searchButton" style="background:#0353C1" @click="submits">
            <i class="el-icon-folder-checked"></i>{{$t('btn_39')}}
          </div>
        </div>
      </div>
      </div>
      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDatadialog" highlight-current-row
                @current-change="handleCurrentChangeTree" border height="530" style="width: 99%;margin: 10px;overflow: auto;"
                :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}" @selection-change="handleChange">
        <el-table-column
          header-align="center"
          align="center"
          :label="$t('label_369') + '.'"
          type="index"
          :index="getIndex"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          :label="$t('label_331')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="code"
          :label="$t('label_124')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('label_664')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="maker"
          :label="$t('label_672')"
          align="center"
        >
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column
          prop="saler"
          :label="$t('label_235')"
          align="center"
        >
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.saler" :hoverMes="scope.row.saler" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('label_666')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="warehouseName"
          :label="$t('label_327')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          :label="$t('label_252')"
          align="center"
        >
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column
          prop="recordTime"
          :label="$t('label_315')"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="stockNum"
          :label="$t('label_468')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="inventoryNum"
          :label="$t('label_472')"
          align="center"
		  width="280"
        >
            <template slot-scope="scope">
              <span  v-if="!typestate">
                <el-input  v-model="scope.row.inventoryNum" :placeholder="$t('input_46')"/>
              </span>
              <span v-else>
                <span>{{scope.row.inventoryNum}}</span>
              </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--弹窗end-->
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import utils from '@/utils/utils'
import calendar from "@/components/list/calendar/calendar";
import file from "@/assets/js/file/file.js";
import exportMes from "@/components/list/export/export";
import popMesBox from "@/components/list/popover/pop";
export default {
  name: 'inventoryRecord',
  components: {
    Page,
    calendar,
    exportMes,
    popMesBox,
  },
  data: function () {
    return {
      loading: true,
      taskName: '',
      inventoryNum: '', // 输入框的值
      Warehouseidtype: 0, // 状态默认
      optionstype: [{  // 状态下拉
        id: 0,
        name: this.$t('label_272')
      }, {
        id: 1,
        name: this.$t('label_457')
      }, {
        id: 2,
        name: this.$t('label_591')
      }, {
        id: 3,
        name: this.$t('label_462')
      }, {
        id: 9,
        name: this.$t('btn_5')
      }],
      timeText: "",  // 实时当前时间
      dateTime: '',   //  非实时当前时间
      tableDatadialog: [], // list 数组
      dialogDeviceSpot: false, // 默认弹窗状态
      tableDataEdit: {
        changeState: 0,
        content: "",
        cycle: "",
        cycleType: '1',
        decimals: 0,
        defaultValue: "string",
        equipmentTypeId: '',
        fileId: '',
        inputType: '1',
        length: 0,
        method: '',
        name: "",
        needPhoto: 0,
        maker: '',
        needPhotoNum: 5,
        needVideo: 0,
        needVideoNum: 1,
        pid: 0,
        remark: "string",
        sort: 0,
        unit: "string",
        weekend: '0',
        month: this.$t('label_245'),
        monthD: '1',
        monthDMes: '1',
      },
      input2: '', //备件编号
      input3: '', // 入库数量
      name4: '',  // 手写出库数量
      pageNum: 1,
      select: 0,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      height: 620,
      MenuRoleList: [],
      exportTitle: this.$t('label_396'),
      options: [],
      name: '', // 下拉选默认项
      tableDataTreeInfo: {},
      factoryDialogTitle: this.$t('btn_14'),
      getTreeMes: '1',
      dialogFactory: false,
      searchDataList: {
        dateTime: ''
      },
      tableDataTreeTimeExport: [],
      tableDataTree: [],
      factoryTypeList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      delelist: [], // 弹框list
      checkList: '', // 下拉选数据
      deviceParamTitle: this.$t('btn_54'), // 弹窗title
      tableDataTreeTime: [], // 页面list
      Warehouseid: '0',
      ckid: '',
      typenumbernew: 0, // 状态id
      typestate: false,  // 判断点击盘点和查看时候的状态
      newparam: ''
    }
  },
  methods: {
    // 状态id
    typenumber(val){
      this.Warehouseidtype = val
    },
    //  仓库id
    updateTable(value) {
      this.Warehouseid = value
    },
    searchPage(param) {
      let dataParam = {
        name: this.taskName,
        state: this.Warehouseidtype,
        warehouseId: this.Warehouseid
      }
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.deviceCheckItemInfoEdit(newParam);
    },
    // 删除按钮
    open() {
      if(this.tableDataTreeInfo=='' || this.tableDataTreeInfo==null ||  this.tableDataTreeInfo==undefined){
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
        return false
      }else if(this.tableDataTreeInfo.state == 3||this.tableDataTreeInfo.state==9){
        this.$message({
          message: this.$t('msg_242'),
          type: 'warning'
        });
        return false
      } else {
        var checktype  =  this.tableDataTreeInfo
        var param = this.tableDataTreeInfo.id;
      }
      if(!param|| param=='' ||param==undefined){
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
        return false
      } else {
        if (checktype.state != 1) {
          utils.messageAlert(this.$t('msg_117'), this.$t('label_358'), this.$t('label_100'));
          return false
        } else {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning',
            center: true
          }).then(() => {
            file.equipmentInspectionInfo(param).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.$message({
                  message: this.$t('msg_14'),
                  type: 'success'
                });
                this.search()
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('label_478')
            });
          });
        }
      }
    },
    // 作废按钮
    tovoid(){
      if(this.tableDataTreeInfo=='' || this.tableDataTreeInfo==null ||  this.tableDataTreeInfo==undefined){
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
        return false
      }else if(this.tableDataTreeInfo.state == 3||this.tableDataTreeInfo.state==9){
        this.$message({
          message: this.$t('msg_242'),
          type: 'warning'
        });
        return false
      }else {
        var checktype  =  this.tableDataTreeInfo
        var param = this.tableDataTreeInfo.id;
      }
      if(!param|| param=='' ||param==undefined){
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
        return false
      } else {
        if (checktype.state != 2 && checktype.state != 3) {
          utils.messageAlert(this.$t('msg_56'), this.$t('label_358'), this.$t('label_100'));
          return false
        } else {
          this.$confirm(this.$t('msg_57'), this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning',
            center: true
          }).then(() => {
            file.Inventoryvoid(param).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.$message({
                  message: this.$t('msg_22'),
                  type: 'success'
                });
                this.search()
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('label_478')
            });
          });
        }
      }
    },
    // 点击盘点 和查看
    Inventorycli(val){
      if(this.tableDataTreeInfo=='' || this.tableDataTreeInfo==null ||  this.tableDataTreeInfo==undefined){   // 判断一下 是否点击查看的数据
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
        return false
      } else {
        this.newparam = this.tableDataTreeInfo.id;
      }
      if(val==1){   // 判断盘点还是查看
        this.typestate = true
      } else {
        this.typestate = false
      }
      let checktype  =  this.tableDataTreeInfo   // 用来判断盘点记录状态
      if(!this.newparam|| this.newparam=='' ||this.newparam==undefined){   // 判断是否勾选数据
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
         return false
      } else if(!this.typestate && checktype.state!=1 && checktype.state!=2){
        utils.messageAlert(this.$t('msg_58'), this.$t('label_358'), this.$t('label_100'));
      } else {
        file.taskQuery(this.newparam).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDatadialog = data.data;
            this.dialogDeviceSpot = true;
            if(val==1){    // 根据val  判断弹框title
              this.deviceParamTitle = this.$t('btn_38');
            } else{
              this.deviceParamTitle = this.$t('btn_54');
            }
            this.search()
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      }

    },
    // list 数据
    deviceCheckItemInfoEdit(param) {
      file.getinventorytaskpage(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTime = data.data.records;
          this.deviceParamTitle = this.$t('btn_54');
          this.pageCount = data.data.total;
          this.pageSize = data.data.size;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
          this.loading =false
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 下拉选
    getCheckList() {
      file.getByDictIdALL({dictId: 3, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.checkList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getPartsList().then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.checkList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    // 仓库下拉选
    getWarehousedown() {
      file.getWarehousedown().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.options = data.data;
          this.options.unshift({name:this.$t('label_272'),id:'0'})
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 过滤
    checkText(type) {
      var data = this.checkList.filter(function(item) {
        return item.key == type;
      });
      if (data != '') {
        return data[0].val
      }
    },
    //  点击暂存
    zancun(){
      var numReg = /^[0-9]*$/
      for(let i=0;i<this.tableDatadialog.length;i++){
        if (this.tableDatadialog[i].inventoryNum && this.tableDatadialog[i].inventoryNum!='' &&!numReg.test(this.tableDatadialog[i].inventoryNum)){   //  正则判断 输入框不为空 并且是数字
          utils.messageAlert(this.$t('input_50'), this.$t('label_358'), this.$t('label_100'));
          return   false
        }
      }
      file.Inventorytaskstaging(this.newparam,this.tableDatadialog).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogDeviceSpot = false;
          this.$message({
            message: this.$t('msg_24'),
            type: 'success'
          });
          this.search()
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 点击提交
    submits(){
      var numReg = /^[0-9]*$/
      for(let i=0;i<this.tableDatadialog.length;i++){
        if(!this.tableDatadialog[i].inventoryNum || this.tableDatadialog[i].inventoryNum=='' || this.tableDatadialog[i].inventoryNum==undefined){
          utils.messageAlert(this.$t('msg_51'), this.$t('label_358'), this.$t('label_100'));
          return false
        } else if (!numReg.test(this.tableDatadialog[i].inventoryNum)){
          utils.messageAlert(this.$t('input_50'), this.$t('label_358'), this.$t('label_100'));
          return   false
        }
      }
      file.Inventorytsubmit(this.newparam,this.tableDatadialog).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogDeviceSpot = false;
          this.$message({
            message: this.$t('msg_24'),
            type: 'success'
          });
          this.search()
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 单选
    handleChange(selection) {
      this.delelist = []
      this.delelist = selection
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    exportClick() {
      this.$refs.exportBox.setExportExcel();
    },
    selectProp: function(index) {
      console.log(index)
      this.select = index
    },
    // 关闭弹窗
    handleClose() {
      this.dialogDeviceSpot = false;
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    handleCurrentChangeTreeTime(info) {},
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
      this.searchPage(param);
    },
  },
  created() {
	  this.MenuRoleList = this.$store.getters.getMenu;
    this.getCheckList(); // 下拉选数据
    this.getWarehousedown()  // 获取仓库下拉
    this.search()
  }
}
</script>

<style scoped>
.el-input{
  width: 200px;
}
.ipt .el-input{
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}
.sele_ipt.el-select {
  width:100px;
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}
.input_wid .el-input{
  width: 50%;
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}

.poin {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/part/inventoryRecord.vue